import { WEBSITES_DATA_FILENAME } from '../../misc/misc.constants';
import { getQueryParamValue } from '../../misc/functions';

// Fetches the websites data, preferring the DB endpoint and falling back to the
// bundled JSON file (or going straight to the file when `?ds=file` is set).
export async function fetchWebsitesData({
  method = 'GET',
}: { method?: string } = {}): Promise<Response> {
  function _fetchFromFile() {
    return fetch(`${__WEBSITES_DATA_URL__}/${WEBSITES_DATA_FILENAME}`, {
      method,
    });
  }

  function _fetchFromDB() {
    return fetch(`${__WLA_BACKEND_URL__}/combined?env=demo`, { method });
  }

  if (getQueryParamValue('ds') !== 'file') {
    try {
      const responseFromDB = await _fetchFromDB();
      if (responseFromDB.ok) return responseFromDB;
      throw new Error(responseFromDB.statusText);
    } catch (error) {
      console.log(
        `Falling back to "${WEBSITES_DATA_FILENAME}", failed to load from DB:`,
        (error as Error).message,
      );
      return await _fetchFromFile();
    }
  } else {
    return await _fetchFromFile();
  }
}
